module.exports = __webpack_public_path__ + "static/img/6202_phase_function_Paper_PointsHejduk_Prediction.09c82a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6202_phase_function_Paper_PointsHejduk_Prediction.png
// module id = pmAV
// module chunks = 0